import { usePropertyHoaDues } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface HoaDuesProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const HoaDues: React.FC<HoaDuesProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Will HOA dues be owed on the property?';
    const [hoaDues, set_hoaDues] = usePropertyHoaDues(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_hoaDues(true);
                return;
            case 'no':
                set_hoaDues(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={hoaDues === undefined ? '' : hoaDues ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonHoaDues'
                    value={hoaDues}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='HOA dues required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
